import { useContext, useEffect } from 'react'

import { Box } from '@fairfashion/design-system'

import { BackButton } from '../../components/BackButton/back-button.comp'

import { QRCodeDetailsHeader } from './components/QRCodeDetailsHeader/qrcode-details-header.comp'
import { QRCodeDetailsJourney } from './components/QRCodeDetailsJourney/qrcode-details-journey.comp'
import { QRCodeDetailsMetrics } from './components/QRCodeDetailsMetrics/qrcode-details-metrics.comp'
import { QRCodeDetailsParts } from './components/QRCodeDetailsParts/qrcode-details-parts.comp'
import {
  QRCodeDetailsContext,
  QRCodeDetailsProvider,
} from './qrcode-details.context'
// import * as Styles from './qrcode-details.styles'

const QRCodeDetailsComp = () => {
  const { actions } = useContext(QRCodeDetailsContext)

  useEffect(() => {
    actions.fetchQrcode()
    actions.fetchItemTraceabilitySteps()
  }, [])

  return (
    <Box direction="column" width="100%" gap={4} padding={3}>
      <BackButton url="/qrcode" />

      <QRCodeDetailsHeader />

      <QRCodeDetailsMetrics />

      <QRCodeDetailsParts />

      <QRCodeDetailsJourney />
    </Box>
  )
}

export const QRCodeDetails = () => {
  return (
    <QRCodeDetailsProvider>
      <QRCodeDetailsComp />
    </QRCodeDetailsProvider>
  )
}
